import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var LimitedMobilitySVG = function LimitedMobilitySVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("polygon", {
    className: "DetailedIcon__foreground-color-fill",
    points: "35.296 24.717 35.296 24.717 35.297 24.718 35.296 24.717"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M2,22.813V35a2,2,0,0,0,2,2h7.382a1,1,0,0,1,.894,1.447l-.552,1.106A1,1,0,0,0,12.618,41H35.834a1,1,0,0,0,.359-1.934l-12.3-4.723a1,1,0,0,1-.591-1.25l1.386-4.157a1,1,0,0,0-.62-1.26L4.657,20.924A2,2,0,0,0,2,22.813Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M22.961,5.4a1.8,1.8,0,0,1,1.8,1.8V21a1.2,1.2,0,0,0,2.4,0V9.6a1.8,1.8,0,0,1,3.6,0V23.957a1.2,1.2,0,0,0,1.209,1.2,1.178,1.178,0,0,0,.84-.354l2.078-2.079a1.8,1.8,0,0,1,2.546,0h0a1.8,1.8,0,0,1,0,2.546l-7.813,7.812A12,12,0,0,1,21.136,36.6H18.761a9.6,9.6,0,0,1-9.6-9.6V14.4a1.8,1.8,0,1,1,3.6,0V21a1.2,1.2,0,1,0,2.4,0V9.6a1.8,1.8,0,0,1,3.6,0V21a1.2,1.2,0,0,0,2.4,0V7.2a1.8,1.8,0,0,1,1.8-1.8m0-2.4a4.208,4.208,0,0,0-4,2.909,4.2,4.2,0,0,0-6.2,3.691v1.006a4.2,4.2,0,0,0-6,3.794V27a12.013,12.013,0,0,0,12,12h2.375a14.306,14.306,0,0,0,10.183-4.218l7.812-7.812a4.2,4.2,0,0,0-5.94-5.94l-.03.03V9.6a4.2,4.2,0,0,0-6.2-3.691,4.208,4.208,0,0,0-4-2.909Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M36.5,37H35a1,1,0,0,1,0-2h1v-.7A1.3,1.3,0,0,1,37.3,33H38v-.5A1.5,1.5,0,0,1,39.5,31H40V30a1,1,0,0,1,2,0v1.5A1.5,1.5,0,0,1,40.5,33H40v.5A1.5,1.5,0,0,1,38.5,35H38v.5A1.5,1.5,0,0,1,36.5,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M36.793,15.485a1,1,0,0,1-.707-1.707l.707-.707-.494-.493a1.307,1.307,0,0,1,0-1.839l.5-.5-.354-.354a1.5,1.5,0,0,1,0-2.122l.353-.353-.707-.707A1,1,0,0,1,37.5,5.293l1.061,1.061a1.5,1.5,0,0,1,0,2.121l-.354.354.354.353a1.5,1.5,0,0,1,0,2.121l-.354.354.354.353a1.5,1.5,0,0,1,0,2.122L37.5,15.192A.993.993,0,0,1,36.793,15.485Zm.353-7.717h0Z"
  }));
};
LimitedMobilitySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
LimitedMobilitySVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Limited Mobility")
};
export default withDetailedIcon(LimitedMobilitySVG);